<template>
  <component :is="tag" v-html="safeHtml"></component>
</template>

<script setup lang="ts">
import { computed } from "vue";
import purify, { SAFE_HTML_ADD_TAGS, SAFE_HTML_ADD_ATTR } from "@/utils/safe-html-purify";

const props = withDefaults(
  defineProps<{
    html: string | null | undefined;
    tag?: string;
  }>(),
  {
    tag: "div",
  }
);

const safeHtml = computed(() => {
  if (!props.html) return "";
  return purify.sanitize(props.html, {
    ADD_TAGS: SAFE_HTML_ADD_TAGS,
    ADD_ATTR: SAFE_HTML_ADD_ATTR,
  });
});
</script>
